import { getMessages } from '../../../../../../../store/constants';
import { ICardCommentsHint } from './types';

export const COMMENTS_ATTACHMENT_TIPS = [
    getMessages().getText('card_form_attachment_tip_1'),
    getMessages().getText('card_form_attachment_tip_2'),
];

export const COMMENTS_SECTIONS_LOAD_MORE = getMessages().getText('card_form_section_comments_load_more');
export const COMMENTS_SECTIONS_EMPTY_PLACEHOLDER_TITLE = getMessages().getText('card_form_section_comments_empty_placeholder_title');

export const COMMENTS_SECTIONS_PLACEHOLDER_HINTS: ICardCommentsHint[] = [
    {
        items: [
            { getText: () => getMessages().getText('card_form_section_comments_empty_placeholder_hint_1-1') },
            { getText: () => getMessages().getText('card_form_section_comments_empty_placeholder_hint_1-2') },
            {
                Icon: require('!!@svgr/webpack!../../../../asidePanel/components/AsidePanelCommentsColumnViewButton/one-column.svg').default,
                getText: () => getMessages().getText('card_form_section_comments_empty_placeholder_hint_1-3')
            },
        ],
    },
    {
        items: [
            { getText: (assignees: number) => getMessages().getText('card_form_section_comments_empty_placeholder_hint_2-1', null, assignees) },
            { getText: () => getMessages().getText('card_form_section_comments_empty_placeholder_hint_2-2') },
        ],
        isAssignees: true,
    },
    {
        items: [
            { getText: () => getMessages().getText('card_form_section_comments_empty_placeholder_hint_3-1') },
            { getText: () => getMessages().getText('card_form_section_comments_empty_placeholder_hint_3-2') },
        ],
    },
    {
        items: [
            { getText: () => getMessages().getText('card_form_section_comments_empty_placeholder_hint_4-1') },
            { getText: () => getMessages().getText('card_form_section_comments_empty_placeholder_hint_4-2') },
            { getText: () => getMessages().getText('card_form_section_comments_empty_placeholder_hint_4-3') },
            { getText: () => getMessages().getText('card_form_section_comments_empty_placeholder_hint_4-4') },
        ],
    },
    {
        items: [
            { getText: () => getMessages().getText('card_form_section_comments_empty_placeholder_hint_5-1') },
            { getText: () => getMessages().getText('card_form_section_comments_empty_placeholder_hint_5-2') },
        ],
    },
    {
        items: [
            { getText: () => getMessages().getText('card_form_section_comments_empty_placeholder_hint_6-1') },
            { getText: () => getMessages().getText('card_form_section_comments_empty_placeholder_hint_6-2') },
        ],
    },
];
